export default __webpack_public_path__ + "static/media/perfil1.dfb44639.jpg";